<style type="text/css">
  .v-menu__content--fixed {
    top: 62px !important;
  }
</style>

<template>
  <v-card class="overflow-hidden">
    <v-app-bar app class="header-box mobile-view">
      <v-toolbar-title>
        <v-img
          max-height="58"
          max-width="218"
          :src="logo_image"
          :lazy-src="logo_image"
        >
        </v-img>
      </v-toolbar-title>
      <div class="header_text" v-if="isFreeTrail == 'yes'">
        <span class="header_span_text" v-if="$route.name != 'pricingPlan'">Pay Now & Get {{deductionPercentage}}% Discount!</span>
        <v-btn @click="$router.push({ name: 'pricingPlan'})" v-if="$route.name != 'pricingPlan'">Pay Now</v-btn>
      </div>
      <div class="header_text" v-else-if="freeTrialOver">
        <span class="header_span_text" v-if="$route.name != 'pricingPlan'">Trial Period Expired!</span>
        <v-btn @click="$router.push({ name: 'pricingPlan'})" v-if="$route.name != 'pricingPlan'">Pay Now</v-btn>
      </div>
      <v-spacer></v-spacer>
      <v-btn class="notification-icon" @click="notificationList" v-if="$route.name != 'pricingPlan'">
        <v-img
          max-height="28"
          max-width="26"
          :src="require('@/assets/images/notification-icon.png')"
        >
        </v-img>
        <span class="notification-dot"></span>
      </v-btn>
      <v-btn class="user-profilebox">
        <v-img
          class="elevation-6"
          alt=""
          :src="profile_image"
          id="profile_pic2"
        >
        </v-img>
        <v-menu offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              class="dropdown-btnbox"
              color="primary"
              dark
              v-bind="attrs"
              v-on="on"
            >
              <v-img
                max-height="18"
                max-width="18"
                :src="require('@/assets/images/blue-dropdown.png')"
              >
              </v-img>
            </v-btn>
          </template>
          <v-list>
            <v-list-item>
              <v-list-item-title
                ><v-btn @click="logout">Logout</v-btn></v-list-item-title
              >
            </v-list-item>
          </v-list>
        </v-menu>
      </v-btn>
    </v-app-bar>
  </v-card>

</template>

<script>
import { Auth } from "aws-amplify";
import {
  GET_PROFILE_DETAIL,
  GET_REFERRAL_DETAIL,
  USER_SIGNOUT,
  USER_DETAILS,
} from "../../store/actions.type";
import { isEmpty } from "lodash";
import JwtService from ".././common/jwt.service";
export default {
  data: () => ({
    profile_image: "",
    isAddClassMainBox: true,
    logo_image: process.env.VUE_APP_ROOT_ICONS_URL + "Logo.png",
    isFreeTrail: '',
    deductionPercentage: 0,
    freeTrialOver: 0,
    isGracePeriodOver:0
  }),
  mounted() {
    this.getProfiledata();
    Fire.$on("picRefresh", (photo) => {
      if (photo) {
        this.profile_image = photo;
      }
    });
    this.profilePic();
    setTimeout(()=>{
      this.isFreeTrail = localStorage.getItem("isFreeTrail");
      this.deductionPercentage = localStorage.getItem("deductionPercentage");
      this.freeTrialOver = parseInt(localStorage.getItem("freeTrialOver"));
    },4000);
  },

  methods: {
    getProfiledata() {
      Auth.currentAuthenticatedUser({
        bypassCache: true,
      })
        .then((user) => {
          let user_details = {
            user_name: user.attributes["custom:name"],
            email: user.attributes["email"],
            mobile_no: user.attributes["custom:phonenumber"],
            password: "",
            profile_name: user.attributes["custom:name"],
            member_id: "",
            profile_image: "",
            selected_value: "",
            cognito_idp: "",
            saveEmail: "",
          };
          this.$store.dispatch(USER_DETAILS, user_details);
          this.$store
            .dispatch(GET_PROFILE_DETAIL, {
              data: {
                aws_cognito_id: user.attributes.sub,
              },
              api: "get-profile-detail",
            })
            .then(() => {
              let response = this.$store.getters.getProfileDetail.data;
              this.$loading(false);
              if (this.$store.getters.getProfileDetail.status == "error") {
                return [];
              } else {
                Fire.$emit("picRefresh", response.photo);
                Fire.$emit("loadData");
              }
            })
            .catch((error) => {
              this.$loading(false);
            });

          this.$store
            .dispatch(GET_REFERRAL_DETAIL, {
              data: {
                aws_cognito_id: user.attributes.sub,
              },
              api: "get-referral-detail",
            })
            .then(() => {
              if (this.$store.getters.getReferralDetail.status == "error") {
                return [];
              }
              this.$loading(false);
            })
            .catch(function (error) {
              this.$loading(false);
            });
        })
        .catch((err) => {
          this.$loading(false);
          this.$router.push({ name: "Login" }).catch(() => {});
        });
      setTimeout(() => {
        this.$router.push({ name: this.$route.name }).catch(() => {});
      }, 2000);
    },
    logout(evt) {
      // return;
      this.saveEmail = JwtService.getCompanyEmail();
      evt.preventDefault();
      swal.fire({
      title: 'Are you sure want to Logout?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#F19700',
      cancelButtonColor: '#b8b4ad',
      confirmButtonText: 'Yes'
    }).then((result) => {
          if (result.isConfirmed) {
            Auth.signOut()
              .then((data) => {
                this.$store
                  .dispatch(USER_SIGNOUT, {
                    data: {
                      aws_cognito_id: atob(localStorage.getItem("cognito_idp")),
                    },
                    api: "logout",
                  })
                  .then(() => {
                    let user_data = null;

                    //vuex cleaning for Deposit Module

                    this.$store.commit("setDepositData", {});
                    this.$store.commit("setSavingAccountFormData", {});
                    this.$store.commit("setBankPoMasterData", {});
                    this.$store.commit("setEditSavingAccountFormData", {});
                    this.$store.commit("setFixedDepositFormData", {});
                    this.$store.commit("setEditFixedDepositFormData", {});
                    this.$store.commit("setReccuringDepositFormData", {});
                    this.$store.commit("setEditReccuringDepositFormData", {});
                    this.$store.commit("setSukanayaSamridhiYojanaFormData", {});
                    this.$store.commit(
                      "setEditSukanayaSamridhiYojanaFormData",
                      {}
                    );

                    //Vuex Cleaning for Mutual Fund Module

                    this.$store.commit("setMutualFundData", {});
                    this.$store.commit("setLumpsumInvestmentFormData", {});
                    this.$store.commit("setMutualFundCompanyData", {});
                    this.$store.commit("setSchemeNameData", {});
                    this.$store.commit("setSchemeNameDetail", {});
                    this.$store.commit("setLumpsumInvestmentEditFormData", {});

                    //Vuex Cleaning Bullions Module

                    this.$store.commit("setBullionsData", {});
                    this.$store.commit("setBarsAndCoinAddFormData", {});
                    this.$store.commit("setBullionTypeData", {});
                    this.$store.commit("setPriceOfPurity", {});
                    this.$store.commit("setBarsAndCoinEditFormData", {});
                    this.$store.commit("setJewelleryAddFormData", {});
                    this.$store.commit("setDigitalGoldAddFormData", {});
                    this.$store.commit("setDigitalEditGoldAddFormData", {});
                    this.$store.commit("setSovereignGoldBondsAddFormData", {});
                    this.$store.commit("setGoldBondData", {});
                    this.$store.commit("setSovereignGoldBondsEditFormData", {});

                    //vuex Cleaning For Registration

                    this.$store.commit("setRegistrationData", {});
                    this.$store.commit("setVerifyEmailData", {});
                    this.$store.commit("setVerifyMobileOtp", {});
                    this.$store.commit("setUserSignin", {});
                    this.$store.commit("setProfileDetail", {});
                    this.$store.commit("setReferralDetail", {});
                    this.$store.commit("setDefaultSubscription", {});
                    this.$store.commit("setUserPlanDetail", {});
                    this.$store.commit("setUserPlanSubscription", {});
                    this.$store.commit("setVerifyRazorpaySignature", {});
                    this.$store.commit("setUserDetails", {});

                    //vuex Cleaning For Profile

                    this.$store.commit("setCancelSubscriptionData", {});
                    this.$store.commit("setFamilyMemberList", {});
                    this.$store.commit("setDeleteFamilyMember", {});
                    this.$store.commit("setFamilyMemberDetail", {});
                    this.$store.commit("setUpdatefamilyMemberDetail", {});
                    this.$store.commit("setUserProfileDetail", {});
                    this.$store.commit("setSaveFamilyMemberDetail", {});
                    this.$store.commit("setUpdateUserProfileDetail", {});
                    localStorage.clear();
                    JwtService.setCompanyEmail(this.saveEmail);
                    this.$router.push({ name: "Login" }).catch(() => {});
                  })
                  .catch(function (error) {});
              })
              .catch((err) => {});
            Swal.fire("Saved!", "", "success");
          } 
        });
    },
    profilePic() {
      if (this.$store.getters.getProfileDetail.data) {
        this.profile_image = this.$store.getters.getProfileDetail.data.photo;
      } else {
        this.profile_image = "";
      }
    },
    notificationList() {
      this.$router.push({ name: "Notification" }).catch(() => {});
    },
  },
};
</script>
